import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        role: '='
    },
    template: `
        <h1>{{ 'role.Add role' | translate }}</h1>
        <manage-permissions-roles-form role="vm.role" form="vm.form"/>
    `
})
export default class {
    constructor (FormFactory) {
        this.form = FormFactory.createFromResource(this.role);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/permissions/roles/add/index.js